var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-container',[_c('a-card',[_vm._v("管理权限")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }